import styled, { css } from 'styled-components';
import { Section } from '@elfsight/lib-stripe-integration';
import { createReadableClass } from '@elfsight/widget-utils';
import type {
  CheckoutPaymentProps,
  PaymentFormLayoutProps,
  PaymentLayoutProps
} from '../../../common';
import { Scrollable } from '../blocks';
import { useCheckoutNarrowness } from '../utils';
import { PaymentFormLayout } from './payment-form-layout';
import { PaymentLayout } from './payment-layout';

const COMPONENT_NAME = 'checkout-payment-flow';

export function CheckoutPayment(props: CheckoutPaymentProps) {
  const { withInternalForm } = props;

  if (withInternalForm) {
    return <PaymentWithForm {...props} />;
  }

  return <Payment {...props} />;
}

export function Payment(props: PaymentLayoutProps) {
  const isNarrow = useCheckoutNarrowness();

  return (
    <Container>
      <Scrollable stretch>
        <Content $isNarrow={isNarrow} $align="flex-start" $stretch>
          <PaymentLayout {...props} />
        </Content>
      </Scrollable>
    </Container>
  );
}

export function PaymentWithForm(props: PaymentFormLayoutProps) {
  const isNarrow = useCheckoutNarrowness();

  return (
    <Container>
      <Scrollable stretch>
        <Content $isNarrow={isNarrow} $align="flex-start" $stretch>
          <PaymentFormLayout {...props} />
        </Content>
      </Scrollable>
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'container'
  })
})`
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 4px;
`;

const Content = styled(Section).attrs<{ $isNarrow: boolean }>({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'content'
  })
})`
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  min-width: 340px;

  ${({ $isNarrow }) =>
    $isNarrow
      ? css`
          margin: 0 auto;
          max-width: 500px;

          padding: 20px 16px 20px 20px;
        `
      : css`
          padding: 40px 56px 40px 60px;
        `};
`;
